import moment from "moment";
import { BaseReq, PaginationReq, PaginationResp, UpdaterResp,FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

export enum CheckTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

export class CheckReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  checkDate: string = moment().format("YYYY-MM-DD"); // 检查日期
  safetyTenantUserId: string = getCurrentUserId(); // 安检负责人
  acceptInspecteTenantUserId: string | undefined = undefined; // 受检负责人
  isChange: boolean = false; // 是否需要整改
  checkRemark: string = ""; // 检查情况
  remark: string = ""; // 内部备注
  imgUrl: string[] = []; // 现场图片
  fileList: FileRecord[]; //附件

}

export class CheckPageReq extends PaginationReq {
  bizNo: string | undefined = undefined; // 安检记录编号
  name: string | undefined = undefined; // 项目名称
  checkStartDate: string | undefined = undefined; // 检查结束日期
  checkFinishDate: string | undefined = undefined; // 检查开始日期
  isChange: boolean | undefined = undefined; // 是否整改
  isBeRelated: boolean | undefined = undefined; // 是否被关联
  safetyTenantUserId: string | undefined = undefined; // 安检负责人
  flowStatus: string = "";   // 状态
  skipProjectRight: number | undefined = undefined;
  addRightBizType: string | undefined = undefined;
  projectId: string | undefined = undefined; // 项目 ID
  firstDisplayProjectId: string | undefined = undefined;
}

export class CheckListRecord extends UpdaterResp {
  id: string = ""; // 安全检查ID
  bizNo: string = ""; // 安全检查编号
  name: string = ""; // 项目名称
  checkDate: string = ""; // 检查日期
  safetyTenantUserId: string = ""; // 安检负责人 ID
  safetyTenantUserName: string = ""; // 安检负责人名称
  checkRemark: string = ""; // 检查记录
  isChange: boolean | undefined = undefined; // 是否整改
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class CheckPageResp extends PaginationResp<CheckListRecord> {}

class SafetyChangeDto {
  safetyChangeId: string = "";
  safetyChangeBizNo: string = "";
}

export class CheckDetailResp extends UpdaterResp {
  id: string = ""; // 安全检查 ID
  projectId: string = ""; // 项目ID
  name: string = ""; // 项目名称
  checkDate: string = ""; // 检查日期
  safetyTenantUserId: string = ""; // 安检负责人
  safetyTenantUserName: string = ""; // 安检负责人
  acceptInspecteTenantUserId: string = ""; // 受检负责人
  acceptInspecteTenantUserName: string = ""; // 受检负责人
  isChange: boolean | undefined = undefined; // 是否整改
  safetyChangeDto: SafetyChangeDto[] = [];
  checkRemark: string = ""; // 检查情况
  remark: string = ""; // 内部备注
  imgUrl: string[] = []; // 现场图片
}

export class CheckSimpleListReq {
  acceptInspecteTenantUserId: string | undefined = undefined; // 受检负责人
  checkDate: string | undefined = undefined; // 检查日期
  safetyTenantUserId: string | undefined = undefined; // 安检负责人
  isChange: boolean | undefined = undefined; // 是否整改
  projectId: string | undefined = undefined; // 项目 ID
  ids: string[] | undefined = undefined;
}

class CheckSimpleRecord {
  id: string = "";
  bizNo: string = "";
}

export class CheckSimpleListResp {
  records: CheckSimpleRecord[] = [];
}
